/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ProductIdentityValue } from './ProductIdentityValue';
import type { RetailerId } from './RetailerId';

export type AggregatedProductIdentityUpdate = {
    type?: AggregatedProductIdentityUpdate.type;
    values: Array<ProductIdentityValue>;
    hasAutoCalculatedThresholds?: boolean;
    partialMatchThreshold?: number;
    fullMatchThreshold?: number;
    retailers?: Array<RetailerId>;
};

export namespace AggregatedProductIdentityUpdate {

    export enum type {
        SKU = 'SKU',
        NAME = 'NAME',
        AI = 'AI',
    }


}

